'use strict';

(function () {
  'use strict';

  angular.module('vnext').config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('blank', {
      url: '',
      abstract: true,
      views: {
        'main': {
          templateUrl: 'vnext/pages/vnext-blank.html'
        }
      }
    }).state('blank.content', {
      url: '',
      abstract: true,
      views: {
        'content': {
          template: '<div ui-view></div>'
        }
      }
    }).state('blank.content.train', {
      url: '/train',
      onEnter: ['$log', 'activityRouter', function ($log, activityRouter) {
        activityRouter.startTrain();
      }]
    }).state('blank.content.intervention', {
      url: '/int?sliderId&tag',
      data: {
        pageTitle: 'pageTitles.home'
      },
      templateUrl: 'vnext/pages/blank/lowmood.html',
      controller: 'InterventionCtrl as vm',
      resolve: {
        user: ['userSvc', function (userSvc) {
          return userSvc.getUser();
        }]
      }
    });
  }]);
})();